import { CustomStepDefinition, LabelType, Options } from '@angular-slider/ngx-slider';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { DateLastVerifiedBucketEnum } from 'src/portal/search-api/models/date-last-verified-bucket-enum';

@Component({
  selector: 'search-filter-slider-last-verified',
  templateUrl: './search-filter-slider-last-verified.component.html',
  styleUrls: ['./search-filter-slider-last-verified.component.scss']
})
export class SearchFilterSliderLastVerifiedComponent implements OnChanges {

  @Input() selectedLastVerified: DateLastVerifiedBucketEnum | undefined;
  @Output() onChangeValue = new EventEmitter<DateLastVerifiedBucketEnum>();

  sliderValue: number = 2;
  sliderOptions: Options = {
    floor: 0,
    ceil: 3,
    showTicks: true,
    showTicksValues:true,
    animate:true,
    rightToLeft: true,
    stepsArray: Object.values(DateLastVerifiedBucketEnum).map((lastVerified: DateLastVerifiedBucketEnum): CustomStepDefinition => {
      return { value: this.lastVerifiedToIndex(lastVerified) };
    }),
    translate: (value: number, label: LabelType): string => {
      return this.indexToLastVerifiedString(value);
    },
  };

  private lastVerifiedToIndex(lastVerified: DateLastVerifiedBucketEnum): number {
    return Object.values(DateLastVerifiedBucketEnum).indexOf(lastVerified);
  }

  private indexTolastVerified(index: number): DateLastVerifiedBucketEnum {
    return Object.values(DateLastVerifiedBucketEnum)[index];
  }

  private indexToLastVerifiedString(index: number): string {
    switch (index) {
      case 0:
        return '10 Years';
      case 1:
        return '5 Years';
      case 2:
        return 'Last Year';
      case 3:
        return 'Recent';
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.selectedLastVerified && this.selectedLastVerified !== undefined) {
      this.sliderValue = this.getSliderValueFromLastVerified(this.selectedLastVerified);
    }
  }

  private getSliderValueFromLastVerified(lastVerified: DateLastVerifiedBucketEnum): number {
    switch (lastVerified) {
      case DateLastVerifiedBucketEnum.ANCIENT:
        return 0;
      case DateLastVerifiedBucketEnum.OLD:
        return 1;
      case DateLastVerifiedBucketEnum.NEW:
        return 2;
      case DateLastVerifiedBucketEnum.RECENT:
        return 3;
      default:
        return 0;
    }
  }

  public onLastVerifiedChange(): void {
    this.onChangeValue.emit(this.indexTolastVerified(this.sliderValue));
  }
}
